import React from 'react';
import "./Extra2.css"

const Extra2 = () => {
    return (
        <div>


            <div className="testimonials-clean">
                <div className="container pb-4">
                    <div className="intro">
                        <h2 className="text-center">Testimonials </h2>
                        <p className="text-center">The pauses can be acts of discovery, exploration and fun synonymous with travel as well. We’ve lived in 5 countries but have traveled through over 50. I’m not a big counter, I count the memories, the experiences and the friendships more.</p>
                    </div>
                    <div className="row people">
                        <div className="col-md-6 col-lg-4 item">
                            <div className="box">
                                <p className="description">A life of full time travel is not as difficult as you may think. There are many clever strategies you can employ to travel around the world </p>
                            </div>
                            <div className="author"><img className="rounded-circle" src="https://thumbs.dreamstime.com/b/handsome-man-black-suit-white-shirt-posing-studio-attractive-guy-fashion-hairstyle-confident-man-short-beard-125019349.jpg" />
                                <h5 className="name text-white">Ben Johnson</h5>
                                <p className="title text-white">CEO of Company Inc.</p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 item">
                            <div className="box">
                                <p className="description">Prioritize. Work out what you are willing to sacrifice and what you aren’t and craft your travel experiences around that..</p>
                            </div>
                            <div className="author"><img className="rounded-circle" src="https://i.imgur.com/o5uMfKo.jpg" />
                                <h5 className="name text-white">Carl Kent</h5>
                                <p className="title text-white">Founder of Style Co.</p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 item">
                            <div className="box">
                                <p className="description">The best way to do this is to live and work in expensive countries. Better to spend the local currency and save your own money for other adventures. </p>
                            </div>
                            <div className="author"><img className="rounded-circle" src="https://image.freepik.com/free-photo/handsome-man-white-shirt-posing-attractive-guy-with-fashion-hairstyle-confident-man-with-short-beard-adult-boy-with-brown-hair-closeup-portrait_186202-8545.jpg" />
                                <h5 className="name text-white">Emily Clark</h5>
                                <p className="title text-white">Owner of Creative Ltd.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>





        </div>
    );
};

export default Extra2;